import { Component } from '@angular/core';

@Component({
  templateUrl: './faq.component.html',
})
export class FaqComponent {

}



// WEBPACK FOOTER //
// ./src/app/marketing/faq.component.ts